import { ReactNode } from 'react';
import classes from './CommunicationCount.module.css';

export function CommunicationCount({
  label,
  count,
}: {
  label: ReactNode;
  count: number;
}) {
  return (
    <div className={classes.communicationCount}>
      <span>{label}</span> <span>{count}</span>
    </div>
  );
}
